import { useSearchParams } from 'react-router-dom';
import { useAppContainerContext } from '../components/AppContainer';

export function useVerifyToken() {
    const [searchParams] = useSearchParams();
    const { loginValue } = useAppContainerContext();

    const tokenFromUrl = searchParams.get('token');
    const tokenFromContext = loginValue?.verifyToken;

    return tokenFromUrl ?? tokenFromContext ?? undefined;
}
